import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// Types
import { NotificationSlugs } from './NotificationsList.types';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';
import { trackClickedNotification } from 'Shared/tracking/tracking';

// Selectors
import { getCurrentWorkspaceType } from 'Shared/selectors/common';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';

// Components
import NewCommentNotification from './NotifiationTemplates/NewCommentNotification';
import NewItemAssigned from './NotifiationTemplates/NewItemAssigned';
import NewItemCreated from './NotifiationTemplates/NewItemCreated';

// Styles
import './NotificationListItem.scss';

type Props = {
  notification;
};

const NotificationListItem = ({ notification }: Props) => {
  const baseClassName = 'NotificationListItem';

  const workspaceType = useSelector(getCurrentWorkspaceType());

  const type = WorkspaceRecentUpdatesHelper.getType(notification);
  const workspaceSlug = WorkspaceRecentUpdatesHelper.getWorkspaceSlug(notification);
  const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(notification);

  const toUrl = PageUrlsUtil.makeWorkspaceMeetingItemCommentsUrl(workspaceSlug, meetingItemUuid);

  const getContent = () => {
    switch (type) {
      case NotificationSlugs.item_assigned:
        return <NewItemAssigned notification={notification} />;
      case NotificationSlugs.workspace_comment_created:
        return <NewCommentNotification notification={notification} />;
      case NotificationSlugs.item_created:
        return <NewItemCreated notification={notification} />;
      default:
        return null;
    }
  };

  const handleNotifcationClick = () => {
    trackClickedNotification(true, type, workspaceType);
  };

  return (
    <Link to={toUrl} className={baseClassName} onClick={handleNotifcationClick}>
      {getContent()}
    </Link>
  );
};

export default NotificationListItem;
